export const WIDGET_FILTER_MULTI_VALUE_ALL = -1;
export const WIDGET_FILTER_ENTITIES_ALL = 1;
export const WIDGET_FILTER_ENTITIES_WITH_REWARD = 2;
